import { getLogLevel, LogLevel } from "../../Utilities/Platform/Logging";
import { Bootstrapper } from "../Bootstrapper";

export class StorageBootstrapper extends Bootstrapper {
    /**
     * @inheritDoc
     */
    public async bootstrap(): Promise<void> {
        try {
            const shouldPersist = await navigator.storage?.persist?.();

            if(getLogLevel() === LogLevel.VERBOSE) {
                console.debug(`Persistent storage ${shouldPersist ? "granted" : "declined"}`);
            }
        } catch(e) {
            console.debug("Unable to persist storage", e);
        }
    }
}
